module.exports = __webpack_public_path__ + "img/ic-donation-medicine.1777f81f.svg";